import { useController } from 'react-hook-form';
import { useGetActionsQuery } from 'apis/cm';
import { useCallback, useMemo } from 'react';

const defaultValue = ['reboot'];
const placeholderData = [];
const ActionNames = {
  reboot: 'Reboot'
};

function useActionAnnotations({ name, devices, actions, from, to, enabled }) {
  const {
    field: { value, onChange }
  } = useController({ name: `${name}.query.actions`, defaultValue });
  const { data, error, isLoading, isFetching } = useGetActionsQuery(
    {
      devices,
      actions,
      runtimeStatuses: ['Completed'],
      from,
      to
    },
    {
      enabled: enabled && actions?.length > 0,
      placeholderData
    }
  );
  const isRebootVisible = value.includes('reboot');
  const toggleRebootVisible = useCallback(() => {
    onChange(isRebootVisible ? [] : ['reboot']);
  }, [onChange, isRebootVisible]);
  const annotations = useMemo(() => (data ? data.map(toAnnotation) : []), [data]);

  return {
    data: annotations,
    error,
    isLoading,
    isFetching,
    isRebootVisible,
    toggleRebootVisible
  };
}

function toAnnotation(action) {
  const {
    instanceId,
    input: { method, device_id: deviceId },
    createdTime
  } = action;

  return {
    annotationId: `${method}-${instanceId}`,
    deviceId,
    name: ActionNames[method] ?? method,
    time: new Date(createdTime).getTime()
  };
}

export { useActionAnnotations };
